import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import "./SignIn.css";
import strings from "../strings";

function SignIn() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginPopup(loginRequest).catch((error) => {
      console.error("Login failed:", error);
    });
  };

  return (
    <div className="sign-in-container">
      <div className="sign-in-content">
        <div className="logo-container">
          <img
            src="https://www.portofoakland.com/wp-content/uploads/2023/12/Port-Logo.svg"
            alt="Port of Oakland Logo"
            className="port-logo"
          />
          <img
            src="/TRC-Logo-Vibrant-Purple.png"
            alt="TRC Logo"
            className="trc-logo"
          />
        </div>
        <div className="sign-in-box">
          <h1>{strings.signIn.welcome}</h1>
          <p>{strings.signIn.signInPrompt}</p>
          <button onClick={handleLogin} className="sign-in-button">
            {strings.signIn.signInButton}
          </button>
          <div className="permissions-info">
            <p className="permissions-message">
              {strings.signIn.permissionsMessage}
            </p>
            <img
              src="/permissions-requested-signin.png"
              alt="Permissions Request Example"
              className="permissions-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
